import { Link } from 'react-router-dom';
import { TreePine } from 'lucide-react';

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: 'smooth' }); }
    else { window.location.href = `/#${id}`; }
  };

  return (
    <footer className="bg-[#1E3F33] text-[#F9F8F6] py-16 px-6 md:px-12 lg:px-24" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <TreePine className="w-5 h-5 text-[#CC5A3D]" />
              <span className="font-heading text-xl font-medium">New Forest Caravans</span>
            </div>
            <p className="text-sm text-[#F9F8F6]/70 leading-relaxed">
              Luxury caravan holidays at Hoburne Park, Christchurch. Book direct, save on fees, and enjoy the New Forest.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium mb-4">Explore</h4>
            <ul className="space-y-2">
              <li><button onClick={() => scrollTo('about')} className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">The Park</button></li>
              <li><button onClick={() => scrollTo('nearby')} className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">What's Nearby</button></li>
              <li><button onClick={() => scrollTo('caravan')} className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">The Caravan</button></li>
              <li><button onClick={() => scrollTo('availability')} className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">Book Now</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium mb-4">SEO Pages</h4>
            <ul className="space-y-2">
              <li><Link to="/hoburne-park-caravan-hire" className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">Hoburne Park Caravan Hire</Link></li>
              <li><Link to="/new-forest-caravan-holidays" className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">New Forest Caravan Holidays</Link></li>
              <li><Link to="/login" className="text-sm text-[#F9F8F6]/70 hover:text-[#CC5A3D] transition-colors">Staff Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium mb-4">Contact</h4>
            <p className="text-sm text-[#F9F8F6]/70 mb-2">agents@assuredtravel.co.uk</p>
            <p className="text-sm text-[#F9F8F6]/70 mb-2">Hoburne Park, Christchurch</p>
            <p className="text-sm text-[#F9F8F6]/70">Dorset BH23 4HP</p>
          </div>
        </div>

        <div className="border-t border-[#F9F8F6]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#F9F8F6]/50">&copy; {new Date().getFullYear()} New Forest Caravan Holidays. All rights reserved.</p>
          <p className="text-xs text-[#F9F8F6]/50">Book direct &middot; Save on fees &middot; Holiday better</p>
        </div>
      </div>
    </footer>
  );
}
